<template>
	<div class="flex xs-12 xs-column">
		<j-card v-if="!graphQlQuery" class="bg4 p4 flex xs-center mb3 fs3 c6">{{
			$t("no_graphql_query")
		}}</j-card>
		<div v-for="(item, i) in schema" :key="i">
			<p class="fs4 c6 fw5 mb1">{{ item.label }}</p>
			<component
				class="mb3"
				:is="item.componentName"
				:for="item.type"
				v-model="form[item.type]"
				v-bind="form"
			/>
		</div>
		<p class="fs4 c6 fw5 mb1">{{ $t("graphql_variables") }}</p>
		<core-monaco-editor :value="computedVariablesJsonString" />
	</div>
</template>

<script>
import gql from "graphql-tag"
import library from "./library.js"
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"
import JCard from "@/components/JCard/"

// import components to use for library
import SelectByCaseId from "./components/SelectByCaseId"
import SelectById from "./components/SelectById"

export default {
	props: {
		graphQlQuery: String,
		// to set default value of component
		values: {
			type: Object,
			default: () => null
		}
	},

	components: {
		CoreMonacoEditor,
		JCard,

		SelectByCaseId,
		SelectById
	},

	data() {
		return {
			isLoading: false,
			schema: [],
			form: {},
			variablesJsonString: null // what we actually send to api
		}
	},

	methods: {
		parseQuery() {
			if (!this.graphQlQuery) return
			// parse this.graphQlQuery into graphql AST using graphql-tag
			const parsedQuery = gql`
				${this.graphQlQuery}
			`
			// assign componentName value based on component/library.js object with same type
			this.schema = parsedQuery?.definitions?.[0]?.variableDefinitions.map(
				item => ({
					type: item?.type?.name?.value,
					variable: item?.variable?.name?.value,
					componentName: library?.find(
						lib => lib.type === item?.type?.name?.value
					)?.componentName,
					label: library?.find(lib => lib.type === item?.type?.name?.value)
						?.label
				})
			)

			if (this.values !== null) {
				let keys = Object.keys(this.values)
				let value = Object.values(this.values)
				keys?.map((item, i) => {
					this.form[item] = value[i]
				})
			}
		},

		massageData() {
			let output = {}
			let keys = Object.keys(this.form)
			let value = Object.values(this.form)
			keys?.map((item, i) => {
				output[this.schema?.find(s => s.type === item)?.variable] = {
					id: value[i]
				}
			})
			return output
		}
	},

	// watch for changes on for
	watch: {
		graphQlQuery: {
			handler() {
				this.parseQuery()
			}
		},
		form: {
			handler() {
				this.variablesJsonString = JSON.stringify(this.massageData())
			},
			deep: true
		},
		variablesJsonString: {
			handler() {
				this.$emit("update:variables", this.variablesJsonString)
			}
		}
	},

	computed: {
		computedVariablesJsonString() {
			if (!this.variablesJsonString) return ""
			return this.variablesJsonString
		}
	},

	beforeUpdate() {
		this.variablesJsonString = JSON.stringify(this.massageData())
	},

	async created() {
		await this.parseQuery()
		this.variablesJsonString = JSON.stringify(this.massageData())
	}
}
</script>
